import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import "../../../../../assets/css/style.css";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import moment from "moment";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";

const ResumeTemplate6 = (props) => {
  const { storeCandidate, getCandidate } = props;
  const [candidateId, setCandidatId] = React.useState("");
  const [candidate, setCandidate] = React.useState(null);

  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatId(candidate?.id);
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (candidateId != "") {
      if (storeCandidate.candidate === null) {
        setIsLoading(true);
        getCandidate(candidateId).then((resp) => {
          setCandidate(resp);
          setIsLoading(false);
        });
      } else if (storeCandidate.candidate !== null) {
        setIsLoading(true);
        setCandidate(storeCandidate.candidate);
        setIsLoading(false);
      }
    }
  }, [candidateId]);

  const downloadPDF = () => {
    // const doc = new jsPDF();
    // doc.html(document.querySelector(".professional-cv"), {
    //   callback: (doc) => {
    //     doc.save("resume.pdf");
    //   },
    // });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du cv en cours...</div>
        </div>
      ) : (
        <>
          <div className="professional-cv">
            <style>
              {`
                .professional-cv {
                  display: flex;
                  font-family: Arial, sans-serif;
                  color: #333;
                  line-height: 1.6;
                }

                .sidebar {
                  width: 30%;
                  background-color: #f7f7f7;
                  padding: 30px;
                }

                .photo-container {
                  text-align: center;
                }

                .photo {
                  border-radius: 50%;
                  width: 150px;
                  height: 150px;
                }

                .contact-info {
                margin: 50px;
                text-align: center;
                }

                .contact-info h2 {
                font-size: 18px;
                  margin-bottom: 10px;
                }

                .contact-info p {
                    margin: 5px 0;
                }

                .content {
                  width: 70%;
                  padding: 20px;
                }

                .cv-header {
                  text-align: left;
                  margin-bottom: 40px;
                }

                .candidate-name {
                  margin: 0;
                  font-size: 36px;
                }

                .job-title {
                  font-size: 24px;
                  color: #666;
                }

                .cv-section {
                  margin-bottom: 20px;
                }

                .section-title {
                  font-size: 24px;
                  border-bottom: 2px solid #333;
                  padding-bottom: 5px;
                  margin-bottom: 10px;
                }

                .experience-list,
                .education-list,
                .skills-list,
                .languages-list {
                  list-style-type: none;
                  padding: 0;
                }

                .experience-item,
                .education-item,
                .skill-item,
                .language-item {
                  margin-bottom: 10px;
                }

                .job-title {
                  font-weight: bold;
                }

                .company-name,
                .job-dates {
                  color: #666;
                }

                 .button-container {
                        position: fixed;
                        right: 20px;
                        top: 50%;
                        transform: translateY(-50%);
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                }

                .btn {
                    padding: 12px 20px;
                    font-size: 16px;
                    cursor: pointer;
                    border: none;
                    border-radius: 5px;
                    color: #fff;
                    background-color: #333;
                }

                .btn-download {
                    background-color: #5cb85c;
                }
                .spinner-container {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100vh;
                }
                @media print {
                  body {
                    background-color: #fff;
                  }
                  .container {
                    box-shadow: none;
                    border: none;
                    padding: 0;
                    border-radius: 0;
                  }
                  .button-container {
                    display: none;
                  }
                  footer, .button-container {
                    display: none;
                  }
                }
              
              `}
            </style>
            <aside className="sidebar">
              <div className="photo-container">
                <div className="profile-avatar">
                  {candidate?.profilePictureUrl ? (
                    <>
                      <img
                        className="img-fluid"
                        src={candidate?.profilePictureUrl}
                        alt={`${candidate?.firstName} ${candidate?.lastName}`}
                      />
                    </>
                  ) : (
                    <>
                      <img
                        className="img-fluid"
                        src="assets/images/avatar/avatar2.png"
                        alt="Avatar"
                      />
                    </>
                  )}
                </div>
              </div>
              <div className="contact-info">
                <h2>Contact Info</h2>
                <p>Email: {candidate?.email}</p>
                <p>Phone: {candidate?.phoneNumber1}</p>
              </div>
            </aside>
            <main className="content">
              <header className="cv-header">
                <h1 className="candidate-name">
                  {candidate?.firstName} {candidate?.lastName}
                </h1>
              </header>
              <section className="cv-section">
                <h2 className="section-title">Présentation</h2>
                <div
                  className="html-content summary-content"
                  dangerouslySetInnerHTML={{ __html: candidate?.summary }}
                />
              </section>
              <section className="cv-section">
                <h2 className="section-title">Expérience Professionnelle</h2>
                <ul className="experience-list">
                  {candidate?.workExperiences.map((job, index) => (
                    <li key={index} className="experience-item">
                      <h3 className="job-title">{job.title}</h3>
                      <p className="company-name">{job.companyName}</p>
                      <p className="job-dates">
                        {new Date(job.startDate).toLocaleDateString()} -{" "}
                        {new Date(job.endDate).toLocaleDateString()}
                      </p>
                      <p className="job-description">{job.description}</p>
                    </li>
                  ))}
                </ul>
              </section>
              <section className="cv-section">
                <h2 className="section-title">Parcours scolaire</h2>
                <ul className="education-list">
                  {candidate?.educations.map((edu, index) => (
                    <li key={index} className="education-item">
                      <h3 className="degree job-title">{edu.degree}</h3>
                      <p className="institute">
                        {edu.institute}, {edu.startYear} - {edu.endYear}
                      </p>
                    </li>
                  ))}
                </ul>
              </section>
              <section className="cv-section">
                <h2 className="section-title">Compétences Professionnelle</h2>
                <ul className="skills-list">
                  {candidate?.skills.map((skill, index) => (
                    <li key={index} className="skill-item">
                      {skill.title}
                    </li>
                  ))}
                </ul>
              </section>
              <section className="cv-section">
                <h2 className="section-title">Langues</h2>
                <ul className="languages-list">
                  {candidate?.languages.map((language, index) => (
                    <li key={index} className="language-item">
                      {language.name}: Ecrit {language.writingLevel}%, Parlé{" "}
                      {language.speakingLevel}%
                    </li>
                  ))}
                </ul>
              </section>
            </main>
            <div className="button-container">
              <button className="btn btn-print" onClick={() => window.print()}>
                Imprimer mon CV
              </button>
              <button className="btn btn-download" onClick={downloadPDF}>
                Télécharger le PDF
              </button>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};
ResumeTemplate6.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, {
  getCandidate,
})(ResumeTemplate6);
